import React from "react";
import { AssistanceMenu } from "../profile/assistance/AssistanceMenu";

export const StayWithUs = () => <AssistanceMenu reasons={['switch','discount','techIssue','meetingWithCS', 'cancel', 'other']} />